module.exports = __webpack_public_path__ + "media/images/lp/industries/realestate/feature-support-c5b4d05075497f1a924dbf0adb8a17de.png";